import { z } from 'zod';
import { bulkCreateServiceDefinitions } from 'wasp/client/operations';
import type { CsvEntityConfig } from '../types';

const validationSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  slug: z.string().min(1, 'Slug is required'),
  serviceTypeKey: z.string().min(1, 'Service Type Key is required'),
  description: z.string().optional().default(''),
  typicalDuration: z.string().optional().default(''),
  isRecurring: z.string().optional().default('false'),
  requiresBooking: z.string().optional().default('false'),
  isActive: z.string().optional().default('true'),
});

export const serviceDefinitionConfig: CsvEntityConfig = {
  entityName: 'Service Definitions',
  entityNameSingular: 'Service Definition',
  columns: [
    { key: 'name', label: 'Name', required: true, description: 'Service name', exampleValue: 'Friday Prayer' },
    { key: 'slug', label: 'Slug', required: true, description: 'Unique URL slug', exampleValue: 'friday-prayer' },
    { key: 'serviceTypeKey', label: 'Service Type Key', required: true, description: 'Key of existing service type', exampleValue: 'prayer' },
    { key: 'description', label: 'Description', required: false, description: 'Optional description', exampleValue: 'Weekly congregational prayer' },
    { key: 'typicalDuration', label: 'Duration (min)', required: false, description: 'Typical duration in minutes', exampleValue: '60' },
    { key: 'isRecurring', label: 'Is Recurring', required: false, description: 'true/false (default: false)', exampleValue: 'true' },
    { key: 'requiresBooking', label: 'Requires Booking', required: false, description: 'true/false (default: false)', exampleValue: 'false' },
    { key: 'isActive', label: 'Is Active', required: false, description: 'true/false (default: true)', exampleValue: 'true' },
  ],
  validationSchema,
  exampleRows: [
    { name: 'Friday Prayer', slug: 'friday-prayer', serviceTypeKey: 'prayer', description: 'Weekly congregational prayer', typicalDuration: '60', isRecurring: 'true', requiresBooking: 'false', isActive: 'true' },
    { name: 'Philosophy Class', slug: 'Philosophy-class', serviceTypeKey: 'education', description: 'Weekly Philosophy study', typicalDuration: '90', isRecurring: 'true', requiresBooking: 'true', isActive: 'true' },
  ],
  bulkCreateAction: bulkCreateServiceDefinitions as any,
  importNotes: [
    'Service Type Key must match an existing service type.',
  ],
};



